<div
  [class]="containerClasses()"
  [attr.aria-label]="ariaLabel()"
  [attr.role]="ariaLabel() ? 'img' : null"
>
  <i [class]="iconClasses()" aria-hidden="true"></i>
</div>
